/* eslint-disable react/prop-types */
import React from 'react'
import { LoadingFlowerProps } from '../types'
import flowerLoadingIcon from 'src/assets/images/CollectionsQuizEntry/ResultCalculationPage/flower-loading-icon.svg'
import flowerLoadingIcon2 from 'src/assets/images/CollectionsQuizEntry/ResultCalculationPage/flower-loading-icon2.svg'

export const LoadingFlower: React.FC<LoadingFlowerProps> = ({ index, isActive }) => (
  <img
    key={index}
    src={isActive ? flowerLoadingIcon2 : flowerLoadingIcon}
    alt={`Loading flower ${index + 1}`}
    className="flower-icon"
  />
)
